import { ApiType } from "/shortcodes";
import * as React from 'react';
export default {
  ApiType,
  React
};